var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dashboard-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.631,
    height: 69.631,
    viewBox: "0 0 69.631 69.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M27,23.625h4.974V36.059H27Z",
    transform: "translate(27.71 23.625)",
    fill: "#0072ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M22.5,18h4.974V42.868H22.5Z",
    transform: "translate(22.263 16.815)",
    fill: "#0072ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M19.184,42.868A12.45,12.45,0,0,1,6.75,30.434h4.974a7.46,7.46,0,1,0,7.46-7.46V18a12.434,12.434,0,0,1,0,24.868Z",
    transform: "translate(3.197 16.815)",
    fill: "#0072ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M66.907,2.25H7.224A4.978,4.978,0,0,0,2.25,7.224V66.907a4.978,4.978,0,0,0,4.974,4.974H66.907a4.98,4.98,0,0,0,4.974-4.974V7.224A4.978,4.978,0,0,0,66.907,2.25Zm0,22.381H32.092V7.224H66.907ZM27.118,7.224V24.631H7.224V7.224ZM7.224,66.907v-37.3H66.907l0,37.3Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#0072ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/Dashboard-icon.860a2301f3fef06a565c030b3c84f52d.svg";
export { ForwardRef as ReactComponent };